import { Box } from '@mui/material'
import { FC } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from '../../../../store'
import { FormsSelector } from '../../../../store/forms'
import {
  PrivateFoundationsActions,
  PrivateFoundationsSelectors,
} from '../../../../store/privateFoundations'
import { SearchForm } from '../SearchForm'
import { PrivateFoundationsList } from '../SearchResults'
import { Paging } from './Paging'

export const PrivateFoundations: FC = () => {
  const dispatch = useDispatch<AppDispatch>()

  const paging = useSelector(PrivateFoundationsSelectors.getPaging)
  const loading = useSelector(PrivateFoundationsSelectors.getLoading)
  const PFCount = useSelector(PrivateFoundationsSelectors.makePFCount)
  const PFs = useSelector(PrivateFoundationsSelectors.makePrivateFoundations)

  const { limit, skip } = paging

  const formId = 'privateFoundation'
  const formValues = useSelector((state: RootState) => FormsSelector.getFormValues(state, formId))

  const { value = '' } = formValues

  const handleSearch = (value: string, limit: number, skip: number) => {
    dispatch(PrivateFoundationsActions.resetPaging())

    const options = { params: { searchedText: value, $limit: limit, $skip: skip } }
    dispatch(PrivateFoundationsActions.fetchPrivateFoundationsAsync({ options }))
  }

  return (
    <Box>
      {/*TODO:filters here will be updated*/}
      <SearchForm
        filters={{
          agencies:[],
          statuses:[],
          phases:[],
          deadline: {
            startDate:null,
            endDate:null
          }
        }}
        formId={formId}
        loading={loading}
        heading="Private foundations"
        onSearch={() => handleSearch(value, limit, skip)}
        handleFiltersChange={(_a) => {}}
        subHeading={`Current funding opportunities from private foundations and corporate giving programs. Each
          foundation offers multiple grants focused on their specific areas of interest and impact
          goals.`}
      />

      <PrivateFoundationsList result={PFs} />

      {!!PFCount && <Paging cb={(limit, skip) => handleSearch(value, limit, skip)} />}
    </Box>
  )
}
